Shopware.Component.register('sw-cms-el-preview-jga-revocation-button', () => import('./preview'));
Shopware.Component.register('sw-cms-el-config-jga-revocation-button', () => import('./config'));
Shopware.Component.register('sw-cms-el-jga-revocation-button', () => import('./component'));

Shopware.Service('cmsService').registerCmsElement({
    name: 'jga-revocation-button',
    label: 'jga-revocation.cms.label',
    component: 'sw-cms-el-jga-revocation-button',
    configComponent: 'sw-cms-el-config-jga-revocation-button',
    previewComponent: 'sw-cms-el-preview-jga-revocation-button',
    defaultConfig: {
        buttonText: {
            source: 'static',
            value: '',
        },
        buttonStyle: {
            source: 'static',
            value: 'primary',
        },
        buttonSize: {
            source: 'static',
            value: 'lg',
        },
    },
});
